import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateBannerData } from '../../actions';


const DraftModeInfo = ({ position, id, data }) => {
  const landingPageData = useSelector(state => state.config.lpdata) || {};
  const dispatch = useDispatch()
  const { type = null, arrayPos = null } = data;

  const movePosition = (move) => e => {
    if (!landingPageData.banners[arrayPos].position) landingPageData.banners[arrayPos].position = position + 1;
    landingPageData.banners[arrayPos].position += move;
    dispatch(updateBannerData(landingPageData.banners))

  };

  //console.log(landingPageData.banners[0].position)
  const styleCfgPosition = { position: "absolute", top: 10, right: 10, opacity: 0.8, color: "black", background: "red", padding: 2, fontSize: "small" };

  const stylePosition = { position: "absolute", bottom: 10, right: 10, opacity: 0.4, color: "black", background: "#FFF", padding: 2, fontSize: "x-small" };
  const styleId = { position: "absolute", bottom: 10, left: 10, opacity: 0.4, color: "black", background: "#FFF", padding: 2, fontSize: "x-small" };
  const styleMove = { zIndex: 1000, position: "absolute", top: 10, left: 10, opacity: 0.4, color: "black", background: "#FFF", padding: 2, fontSize: "x-small" };
  const styleOverride = { zIndex: 1000, position: "absolute", top: 10, left: 10, opacity: 0.4, color: "black", background: "red", padding: 2, fontSize: "x-small" };

  return (
    <Fragment>
        {type==='banner' && landingPageData.banners[arrayPos].position!==position+1 && <div style={styleCfgPosition}>PUSHED: {landingPageData.banners[arrayPos].position}</div>}
         <div style={stylePosition}>{position+1}</div>
        {id && <div style={styleId}>{id}</div>}
        {type==='override' && <div style={styleOverride}>OVERRIDE</div>}
        {type==='banner' && <div style={styleMove}>
          <span onClick={movePosition(-1)}>Left</span>&nbsp; 
          <span onClick={movePosition(1)}>Right</span>
          </div>}
    </Fragment>
  );
};

export default DraftModeInfo;
